import { apiClient } from "helpers/api_helper";
import { toast } from "react-toastify";
// export const getPolicy = async () => {
//   const response = await apiClient.get("/api/v1/StorePolicy/GetActiveStorePolicy");
//   return response.data.data;
// };

export const getPolicy = async () => {
  const res = await apiClient.get("/api/v1/StorePolicy/GetActiveStorePolicy");
  return res.data; 
};

export const updatePolicy = async (payload: {
  returnDays: number;
  exchangeDays: number;
  buyBackDays: number;

}) => {
  const response = await apiClient.post("/api/v1/StorePolicy/InsertOrUpdateStorePolicy", payload);
  return response.data;
};
